export enum CalculationMethodEnum {
  "FIXED-AMOUNTS" = "FIXED-AMOUNTS",
  "INCREMENTAL-LADDER" = "INCREMENTAL-LADDER",
  "INCREMENTAL-LADDER-WITH-RESET" = "INCREMENTAL-LADDER-WITH-RESET",
  "INCREMENTAL-LADDER-WITH-RESET-AND-RECOVERY" = "INCREMENTAL-LADDER-WITH-RESET-AND-RECOVERY",
}

export enum ProgramStatusEnum {
  ACTIVE = "ACTIVE",
  CANCELLED = "CANCELLED",
}

export enum YesNoEnum {
  YES = "YES",
  NO = "NO",
}

export enum IncentiveStructureEnum {
  "GIFTCARD-BASED" = "GIFTCARD-BASED",
}

export enum ValidationRateEnum {
  "WEEKDAYS" = "WEEKDAYS",
}

export enum AssignCMCoordinatorEnum {
  HIDDEN = "hidden",
  OPTIONAL = "optional",
  MANDATORY = "mandatory",
}

export enum FieldVisibilityEnum {
  HIDDEN = "hidden",
  OPTIONAL = "optional",
  MANDATORY = "mandatory",
}

export enum WeekdaysEnum {
  MONDAY = "1",
  TUESDAY = "2",
  WEDNESDAY = "3",
  THURSDAY = "4",
  FRIDAY = "5",
}
